export enum DataMutationMode {
  Edit, Send
}